import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { TraductionDTO } from '@/models/TraductionDTO';
import { Dashboard } from '@/models/Dashboard';
import { Widget } from '@/models/Widget';
import { FiltreStats } from '@/models/FiltreStats';
import { PreventiveDateParameters } from '@/models/PreventiveWidgetItems';

class HomeService{
    public async getPreventiveOutData(filtre: FiltreStats): Promise<any>{
        return http.get(Routes.InterventionRoutes.GetInterventionSinceMonth('12'), {params:filtre});
    }

    public async getPreventiveCircleData(preventiveDateParameters: PreventiveDateParameters): Promise<any>{
        return http.get(Routes.InterventionRoutes.GetInterventionPeriod(preventiveDateParameters.dateDebut, preventiveDateParameters.dateFin),
            {params:preventiveDateParameters.filtre});
    }

    public async getEstimateData(siteIds: FiltreStats): Promise<any>{
        return http.get(Routes.EstimateRoutes.GetEstimate(), {params:siteIds});
    }

    public async getPreventiveChartData(preventiveDateParameters: PreventiveDateParameters): Promise<any>{
        return http.get(Routes.InterventionRoutes.GetInterventionPeriodMonth(preventiveDateParameters.dateDebut, preventiveDateParameters.dateFin),
            {params:preventiveDateParameters.filtre});
    }

    public async getInterventionRequestData(siteIds: FiltreStats): Promise<any>{
        return http.get(Routes.DemandeInterventionRoutes.GetRequestIntervention('12'), {params:siteIds});
    }

    public async getBillingData(filtre?: FiltreStats): Promise<any>{
        return http.get(Routes.BillingRoutes.GetBilling(), {params: filtre});
    }

    public async getCommunication(): Promise<any>{
        return http.get(Routes.CommunicationRoutes.GetCommunication());
    }

    public async setCommunicationVue(idCommunication: string): Promise<any>{
        return http.put(Routes.CommunicationRoutes.SetCommunicationVue(idCommunication));
    }

    public async setCommunicationEtreContacte(idCommunication: string): Promise<any>{
        return http.put(Routes.CommunicationRoutes.SetCommunicationEtreContacte(idCommunication));
    }

    public async setCommunicationEnSavoirPlus(idCommunication: string): Promise<any>{
        return http.put(Routes.CommunicationRoutes.SetCommunicationEnSavoirPlus(idCommunication));
    }

    public async setCommunicationNePlusAfficher(idCommunication: string): Promise<any>{
        return http.put(Routes.CommunicationRoutes.SetCommunicationNePlusAfficher(idCommunication));
    }

    public async getNbNouvellesReclamations(): Promise<any>{
        return http.get(Routes.ReclamationRoutes.GetNbNouvellesReclamations());
    }

    public async getLangues(): Promise<any>{
        return http.get(Routes.LangueRoutes.RecupererLanguesDisponibles());
    }
    public async setLangue(langueId: number): Promise<any>{
        return http.post(Routes.LangueRoutes.EnregistrerLangue(langueId));
    }
    public async getLangueSelectionnee(): Promise<any>{
        return http.get(Routes.LangueRoutes.RecupererLangueSelectionnee());
    }
    public async getTraductions(): Promise<TraductionDTO[]>{
        return http.get(Routes.TraductionRoutes.RecupererTraductions());
    }

    public async getDashboards(): Promise<any>{
        return http.get(Routes.DashboardRoutes.GetDashboard());
    }

    public async getDashboard(id: number): Promise<any>{
        return http.get(Routes.DashboardRoutes.GetDashboardById(id));
    }

    public async postDashboard(dashboard: Dashboard): Promise<any>{
        return http.post(Routes.DashboardRoutes.GetDashboard(), dashboard);
    }

    public async putDashboard(dashboard: Dashboard): Promise<any>{
        return http.put(Routes.DashboardRoutes.GetDashboard(), dashboard);
    }

    public async changeWidgetPosition(widget: Widget, nouvellePosition: number): Promise<any>{
        return http.post(Routes.WidgetsRoutes.ChangeWidgetPosition(nouvellePosition), widget);
    }

    public async deleteDashboard(dashboard: Dashboard): Promise<any>{
        return http.delete(Routes.DashboardRoutes.DeleteDashboard(dashboard.id));
    }

    public async getWidgets(): Promise<any>{
        return http.get(Routes.WidgetsRoutes.GetWidgets());
    }

    public async postWidget(widget: Widget): Promise<any>{
        return http.post(Routes.WidgetsRoutes.GetWidgets(), widget);
    }

    public async deleteWidget(widgetId: number): Promise<any>{
        return http.delete(Routes.WidgetsRoutes.DeleteWidgets(widgetId));
    }
}

export default new HomeService();
